/**
 * Locale trimmed to language enum
 */
export enum Language {
  ENGLISH = 'en',
  FRENCH = 'fr',
  SPANISH = 'es',
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/common/src/i18n/index.ts